import Vuetify from '@/plugins/vuetify'

const i18n = {
  state: {
    current_lang: Vuetify.locale.current // Language Code for Vuetify i18n Module
  },
  mutations: {
    SET_I18N_CURRENT_LANGUAGE(state, payload) {
      Vuetify.locale.current = payload
      state.current_lang = payload
    }
  }
}

export default i18n
